import fp from 'lodash/fp'
import { combine, withAsyncEffect, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'

import TournamentsOverviewComponent from './component'

export const TournamentsOverview = combine(
  withContext(
    'tournamentService',
    ServicesContext,
    fp.prop('tournamentService')
  ),
  withAsyncEffect({
    deps: [],
    dataName: 'tournaments',
    async asyncAction({ tournamentService }) {
      // TEMP solution
      const { SPORT_TYPES } = tournamentService
      const { content } = await tournamentService.queryTournamentsBySportType(
        SPORT_TYPES.TENNIS_ATP
      )

      return content
    },
  })
)(TournamentsOverviewComponent)
